import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Grid, Paper, Tab } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { LoadingWidget } from '../../../../widgets';
import InformacionEstudianteComponent from './components/InformacionEstudiante';

const PanelFamiliaresView = () => {
  const familiaresStore = Redux.useSelector((state) => state.familiares);
  const [tab, setValue] = React.useState('1');

  const handleTabs = (event, newValue) => {
    setValue(newValue);
  };

  React.useEffect(() => {
    // const fetchData = async () => {
    //   await asistenciasFamiliaresAction(dispatch, activo.id, {
    //     idEntidad: entidadesStore.activo.id,
    //   });
    // };
    // fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <LoadingWidget
          isLoading={familiaresStore.loadingAll}
          text={'Cargando datos...'}
        />
      </Grid>
      <Grid item md={4}>
        <InformacionEstudianteComponent />
      </Grid>
      <Grid item md={8}>
        <Paper elevation={4}>
          <TabContext value={tab}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleTabs} aria-label="lab API tabs example">
                <Tab label="Estudiantes" value="1" />
              </TabList>
            </Box>
            <TabPanel value="1" sx={{ p: 0 }}></TabPanel>
          </TabContext>
        </Paper>
      </Grid>

      {/* <ModalComponent
        id="modalFormFamiliares"
        title={`${
          activo
            ? `Editar ${activo.nombre}-${activo.nivelAcademico.nivelAcademico.nombre}`
            : "Nueva sección"
        }`}
        open={openModalForm}
        maxWidth="sm"
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormFamiliares
          activo={activo}
          setOpenModalForm={(val) => setOpenModalForm(val)}
        /> 
      </ModalComponent> */}
    </Grid>
  );
};

export default PanelFamiliaresView;
